import React from 'react';

const BusinessList = (props) => {
  const thumbnail = {
    backgroundImage : `url(${props.items.image})`
  }

  return (
    <div className="BusinessList">
      <div className="businessList-thumbnail" style = {thumbnail}>

        <div className="wrap-businessList-text">
          {props.items.thumbnailText.map((el, index) => {
            return <p key = {index}>{el}</p>
          })}
        </div>
        
      </div>

      <div className="businessList-text">
        <p className="businessList-title">{props.items.title}</p>
        <p>{props.items.text}</p>
      </div>
    </div>
  );
}

export default BusinessList;